import capping from "../services/mechanics.capping";
import notification from "../services/notification";
import { stat } from "fs";

export default {
    namespaced: true,

    state: {
        loading: false,
        error: false,
        errors: null,
        modal: {
            save: {
                status: false,
                type: null
            },
            remove_user: {
                status: false,
                index: null
            },
            remove_frequency: {
                status: false,
                id: null,
                index: null
            }
        },
        delete_array: [],
        reload: false,
        remove_frequency_index: null,

        amount_capping: {},
        capping_header_id: null,
        add_capping: [],
        update_capping: [],
        delete_capping: [],
        transaction_capping: {},

        notification_capping: {},

        users: [],
        user_keyword: null,
        update_notification_capping: {},
        lock: false,
        delete_users: []
    },
    
    mutations: {
        loading(state, value) {
            state.loading = value;
        },

        errors(state, errors) {
            state.error = true;
            if (errors != null) {
                state.errors = errors.errors;
            } else {
                state.errors = errors;
            }
        },

        setModal(state, param) {
            state.modal[param.type].status = param.status;

            if (param.type === "save") {
                state.modal[param.type].type = param.sub_type;
            }

            if (param.type === "remove_user") {
                state.modal[param.type].index = param.index;
                state.modal[param.type].id = param.id;
            }

            if (param.type === "remove_frequency") {
                state.modal[param.type].id = param.id;
                state.modal[param.type].index = param.index;
            }
        },

        getAmountCapping(state, values) {
            state.capping_header_id = values.earn[0].capping_header_id;
            state.amount_capping = values;
        },

        setAdd(state, values) {
            state.add_capping = values.values;
        },

        setUpdate(state, values) {
            state.update_capping = values.values;
        },

        setDelete(state, values) {
            if (values != null) {
                state.delete_array.push(values.id);
                state.remove_frequency_index = values.index;
            }

            if (state.delete_array.length > 0) {
                state.delete_capping = {
                    "ids": state.delete_array
                };
            } else {
                state.delete_capping = [];
            }
        },

        getTransactionCapping(state, values) {
            state.capping_header_id = values.earn[0].capping_header_id;
            state.transaction_capping = values;
        },

        setReload(state, status) {
            state.reload = status;
        },

        getNotificationCapping(state, values) {
            state.notification_capping = values;
        },

        getUsers(state, values) {
            state.users = values;
        },

        setNotificationCapping(state, values) {
            state.update_notification_capping = values;
        },

        setLock(state, lock) {
            state.lock = lock;
        },

        setDeleteUsers(state, user) {
            if (user != null) {
                state.delete_users.push(user);
            } else {
                state.delete_users = [];
            }
        }
    },

    actions: {
        async getAmountCapping ({ commit }) {
            let response = await capping.getAmountCapping();
            commit("getAmountCapping", response.amount);
            commit("setLock", response.lock);
        },

        async getTransactionCapping ({ commit }) {
            let response = await capping.getTransactionCapping();
            commit("getTransactionCapping", response.transaction);
            commit("setLock", response.lock);
        },

        async saveNotifications ({ commit, state }) {
            commit("loading", true);
            try {
                let response = await capping.saveNotificationCapping(state.update_notification_capping);
                commit("loading", false);
                notification.success("Saved Successfully.");
                commit("setReload", true);
                commit("setDeleteUsers", null);
                commit("errors", null);
            } catch (errors) {
                commit("loading", false);
                commit("errors", errors);
                notification.warning("Oops, cannot update Notification Capping");
            }
        },

        async saveAmount ({ commit, state, dispatch }) {
            commit("loading", true);
            try {
                let response = await capping.saveAmountCapping({
                    "header_type": "amount",
                    "add": state.add_capping,
                    "update": state.update_capping,
                    "delete": state.delete_capping
                });
                commit("loading", false);
                notification.success("Saved Successfully.");
                commit("setReload", true);
            } catch (errors) {
                commit("loading", false);
                commit("errors", errors);
                notification.warning("Oops, cannot update Amount Capping.");
            }
        },

        async saveTransaction ({ commit, state }) {
            commit("loading", true);
            try {
                let response = await capping.saveTransactionCapping({
                    "header_type": "transaction",
                    "add": state.add_capping,
                    "update": state.update_capping,
                    "delete": state.delete_capping
                });
                commit("loading", false);
                notification.success("Saved Successfully.");
                commit("setReload", true);
            } catch (errors) {
                commit("loading", false);
                commit("errors", errors);
                notification.warning("Oops, cannot update Transaction Capping.");
            }
        },

        async getNotificationCapping ({ commit }) {
            commit("loading", true);
            try {
                let response = await capping.getNotificationCapping();
                commit("loading", false);
                commit("getNotificationCapping", response);
            } catch (errors) {
                commit("loading", false);
                commit("errors", errors);
            }
        },

        async getUsers ({ commit }, keyword) {
            commit("loading", true);
            try {
                let response = await capping.getUsers({
                    "search": keyword
                });
                commit("loading", false);
                commit("getUsers", response.list);
            } catch (errors) {
                commit("loading", false);
                commit("errors", errors);
            }
        }
    }
}